'use client';

/**
 * 본문 CTA 캡슐 버튼 (Figma 2635:65339). 버튼 자체는 호출부가 만들고
 * 클래스만 공유한다 — 문의는 퍼널 trigger, 케이스리뷰는 모달 opener 라 동작이 다르다.
 *
 * 본문/CMS 공용 pill(`CTA_PILL_CLASSNAME`, 파란 배경)과 배색이 달라 그쪽 상수를
 * 쓰지 않는다. 공용 상수를 이 시안에 맞추면 뉴스 상세와 CMS CTA 가 함께 바뀐다.
 */
export const CTA_BOX_BUTTON_CLASSNAME =
  'group flex h-10 items-center justify-center rounded-[30px] border border-[#bec2cc] bg-3b-background-surface px-3.5 transition-colors hover:bg-[#ff412d] xl:h-12 xl:rounded-[40px] xl:border-0 xl:bg-3b-background-medium xl:px-8';

export const CTA_BOX_BUTTON_TEXT_CLASSNAME =
  'text-[14px] font-semibold leading-4 tracking-[-0.128px] text-3b-text-primary transition-colors group-hover:text-3b-text-contrast xl:text-[16px] xl:leading-6 xl:tracking-[-0.18px]';

/**
 * 본문 안에 들어가는 CTA 네이비 박스 (Figma 2635:65339). 위치는 CMS 작성자가
 * 본문에서 정한다.
 *
 * 문구와 버튼을 모두 호출부가 넣는다 — 문의·케이스리뷰는 i18n 고정 문구를,
 * `CtaWithInfo` 는 MDX 작성자가 쓴 문구를 넘긴다.
 *
 * `description` 이 없으면 문단 자체를 렌더하지 않는다 — 빈 `<p>` 를 남기면
 * 제목 아래에 3px gap 만큼의 빈 줄이 생긴다.
 */
export default function CtaBox({
  title,
  description,
  children,
}: {
  title: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-5 rounded-[20px] bg-3b-blue-light-900 p-10">
      {/* cms-typo-exempt — 이 박스는 본문(div.blog.cms) 안에 렌더되므로 붙이지 않으면
          mdx-container.css 의 `.blog p`(18px/160%/-0.3px/500)가 특정도에서 아래
          유틸리티를 이겨 폰트 스펙이 무시된다 */}
      <div className="flex flex-col items-center gap-[3px] text-center">
        {/* break-keep 이 없으면 모바일에서 어절 중간이 끊겨 마지막 줄에 "요?"
            한 조각만 남는다 — 시안은 한 줄이라 이 상황을 정의하지 않는다 */}
        <p className="cms-typo-exempt break-keep text-[18px] font-semibold leading-7 tracking-[-0.256px] text-3b-text-contrast xl:text-[20px] xl:tracking-[-0.336px]">
          {title}
        </p>
        {description ? (
          <p className="cms-typo-exempt text-[12px] font-normal leading-[18px] tracking-[0.016px] text-3b-text-hint xl:text-[14px] xl:leading-[22px] xl:tracking-[-0.128px]">
            {description}
          </p>
        ) : null}
      </div>
      {children}
    </div>
  );
}
